import React, { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { api, formatApiErrorDetail } from "../lib/api";
import { useAuth } from "../lib/auth";

export default function SetPassword() {
  const { user, refresh } = useAuth();
  const nav = useNavigate();
  const [current, setCurrent] = useState("");
  const [pw1, setPw1] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  if (!user) return <Navigate to="/login" replace />;

  const canSubmit = current && pw1 && pw2 && !busy;

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (pw1 !== pw2) { setErr("The two new passwords don't match. Try again."); return; }
    if (pw1.length < 8) { setErr("Pick something at least 8 characters — a short phrase works well."); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: pw1 });
      await refresh();
      nav("/dashboard", { replace: true });
    } catch (e2) {
      setErr(formatApiErrorDetail(e2.response?.data?.detail) || e2.message);
    } finally { setBusy(false); }
  };

  const forced = user.must_change_password;

  return (
    <div className="ach-login-wrap" data-testid="set-password-page">
      <form className="ach-login-card" onSubmit={submit} data-testid="set-password-form">
        <div className="ach-login-brand">
          <img src="/assets/logo-mark.png" alt="All Cranes" style={{maxWidth: 260, width: "80%", height: "auto", margin: "0 auto 6px"}} />
          <div className="tag" style={{fontSize:14, marginTop:6}}>Set your own password</div>
        </div>
        <p style={{fontSize:13, color:"var(--ach-text-1)", lineHeight:1.5, marginBottom:16}}>
          {forced
            ? "Welcome. Before you can start using the system, please replace the temporary password you were given with one only you know."
            : "Change your password. You'll need to know your current one first."}
        </p>
        <div className="ach-field" style={{marginBottom: 12}}>
          <label>{forced ? "Temporary password you were given" : "Current password"}</label>
          <input data-testid="sp-current" type="password" value={current} onChange={(e)=>setCurrent(e.target.value)} required autoFocus />
        </div>
        <div className="ach-field" style={{marginBottom: 12}}>
          <label>New password <span style={{color:"var(--ach-text-2)", fontWeight:400}}>(at least 8 characters)</span></label>
          <input data-testid="sp-new" type="password" value={pw1} onChange={(e)=>setPw1(e.target.value)} required />
        </div>
        <div className="ach-field" style={{marginBottom: 12}}>
          <label>Type it again to confirm</label>
          <input data-testid="sp-confirm" type="password" value={pw2} onChange={(e)=>setPw2(e.target.value)} required />
        </div>
        {err && (
          <div style={{color:"var(--ach-red)", background:"var(--ach-red-tint)", padding:"8px 12px", borderRadius:8, fontSize:12, marginBottom:12}} data-testid="sp-error">
            {err}
          </div>
        )}
        <button className="ach-btn ach-btn--primary" type="submit" disabled={!canSubmit} data-testid="sp-submit" style={{width:"100%", justifyContent:"center"}}>
          {busy ? "Saving…" : "Save new password →"}
        </button>
      </form>
    </div>
  );
}
